import { checkUserQueryParams } from '@bingads-webui-campaign/global-app-init';
import { keepAliveInstance } from '@bingads-webui/keep-alive';
import { updateGlobalQualtricsData } from '@bingads-webui-campaign/qualtrics';

import { getInstrumentation, getInstrumentationService } from '../instrumentation';

export function setupInstrumentation({
  serverContext,
  devConfig,
  setInstrumentationService,
  subSystemName,
}) {
  // Create new instrumentationScenario and make it available to the rest of the wizard
  const instrumentation = getInstrumentation({
    serverContext,
    devConfig,
    subSystemName,
  });
  const instrumentationService = getInstrumentationService({ instrumentation, serverContext });
  setInstrumentationService(instrumentationService);

  return instrumentation;
}

export function setupGlobal({
  serverContext,
  devConfig,
  setInstrumentationService,
  subSystemName,
}) {
  // Update url with new User
  checkUserQueryParams(serverContext, true);

  // Valid user cookie should be set now, safe to start keep-alive polling
  keepAliveInstance.start();

  updateGlobalQualtricsData(serverContext);

  return setupInstrumentation({
    serverContext,
    devConfig,
    setInstrumentationService,
    subSystemName,
  });
}
